import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28570e8e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=28570e8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28570e8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28570e8e')) {
      api.createRecord('28570e8e', component.options)
    } else {
      api.reload('28570e8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28570e8e&scoped=true", function () {
      api.rerender('28570e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/index.vue"
export default component.exports